import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "../client";
import type { OverviewResponse } from "../types";

// fromIso/toIso are a caller-computed, explicit [from, to) window (see
// utils/period.ts's computeWindow) — replaced the old "1d"/"7d"/"30d"/"all"
// range enum + before= cursor pagination. Required, not defaulted here:
// AppShell.tsx/Control.tsx (which only need SOME recent window, not a
// user-navigable one) compute their own stable window once via useMemo at
// the call site rather than this hook silently picking one — Date.now()
// called fresh on every render would otherwise produce a new queryKey (and
// therefore a refetch) practically every render.
export function useOverview(fromIso: string, toIso: string, botInstanceId?: string) {
  return useQuery({
    queryKey: ["overview", fromIso, toIso, botInstanceId],
    queryFn: () => api.get<OverviewResponse>("/overview", { from_ts: fromIso, to_ts: toIso, bot_instance_id: botInstanceId }),
    refetchInterval: 5000,
    // Пейджинг периода (стрелки ←/→ на Overview) меняет fromIso/toIso, а
    // значит и queryKey — без этого react-query на смену ключа отдаёт
    // data=undefined до ответа нового запроса, и Overview.tsx рендерит
    // "Загрузка…" вместо графика (курс BTC пропадает с экрана на долю
    // секунды). keepPreviousData держит данные СТАРОГО периода на экране,
    // пока грузится новый.
    placeholderData: keepPreviousData,
  });
}
